import { hasOwnMenu } from './customMenuHeads';
import { isTransientMenuId } from './transientMenuIds';

/**
 * Слот пам'яті сеансу для розділу меню модуля (ключі navCollapsed прототипу v4) або undefined, якщо розділ зберігається для модуля
 * (menuOpenStore): «Налаштування» — один на шаблон меню (n5_settings завдань, n6_settings бази знань, n7_settings усіх інших модулів — тож
 * розгорнуті «Налаштування» лишаються такими й в іншому модулі того самого шаблону, доки його не відкрито заново), «Проєктування» — на модуль
 * (md_<модуль>), розділи типів — на модуль (rt_<модуль>_<розділ>). Чиста функція.
 */
export function menuSessionSlot(moduleKey: string, id: string): string | undefined {
  if (!isTransientMenuId(id)) return undefined;
  if (id === 'settings') return `settings:${hasOwnMenu(moduleKey) ? moduleKey : '*'}`;
  return `${id}@${moduleKey}`;
}
